import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id D6CC1545-8778-4A0D-9B2B-7A34DB91ADD9
 * name format-text-rotation-down-vertical
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-text-rotation-down-vertical.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatTextRotationDownVerticalIcon = createSvgIcon(<><path d="M15.25 4H13.75L9 15H11.1L12 12.8H17L17.9 15H20L15.25 4M12.63 11L14.5 6L16.37 11H12.63M5 17.5L8 14.5H6V2H4V14.5H2L5 17.5M22 20L19 17V19H6.5V21H19V23L22 20Z" /></>, 'FormatTextRotationDownVerticalIcon');
export default FormatTextRotationDownVerticalIcon